const rowStyles = {
  idCol: {
    display: "block",
    width: "100%",
    whiteSpace: "nowrap",
  },
};

export default rowStyles;
